<template>
  <div class='table-box'>
    <global-tag>
      <el-form :inline='true' :model='searchlist' class='demo-form-inline' size='mini'>
        <el-form-item label='姓名:'>
          <el-input v-model='searchlist.customerName' placeholder='请输入'></el-input>
        </el-form-item>
        <el-form-item label='联系电话:'>
          <el-input v-model='searchlist.phone' placeholder='请输入'></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='searchlistdata'>查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type='info' @click='searchlistReset'>重置
          </el-button>
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </global-tag>
    <!-- 表格盒子 -->
    <div class='table_card'>
      <el-table :data='tableData' :header-cell-style="{ background: '#f8fafa' }" border highlight-current-row>
        <el-table-column fixed type="index" align="center" label="序号" width="60">
        </el-table-column>
        <el-table-column align='center' prop='customerName' label='姓名'></el-table-column>
        <el-table-column prop="gender" label="性别" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "女" : "男" }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop='age' label='年龄'></el-table-column>
        <el-table-column align='center' prop='phone' label='手机号码'></el-table-column>
        <el-table-column align='center' prop='contact[0].contactName' label='监护人'></el-table-column>
        <el-table-column align='center' prop='contact[0].phone' label='监护人联系方式'></el-table-column>
        <el-table-column align='center' label='操作' fixed='right' width="220">
          <template slot-scope='scope'>
            <button class='tabBtn' @click="showDialog('健康报告', scope.row)">健康报告</button>
            <button class='tabBtn' @click="showDialog('告警信息', scope.row)">告警信息</button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination :page-size='pageConfig.pageSize' layout='total, prev, pager, next, jumper'
        @current-change='handleCurrentChange' :total='pageConfig.total'></el-pagination>
    </div>
    <evaList  :dialogTitle="dialogTitle" :isShow="showDialogVisible" :customerId="customerId" @dialogClose="dialogClose"></evaList>
    <Alarmlist  :dialogTitle="dialogTitle" :isShow1="showDialogVisible1" :customerId="customerId" @dialogClose="dialogClose"></Alarmlist>
  </div>
</template>

<script>
import '@/assets/css/system.css'
import { post } from '@/api/requrestHttp'
import evaList from './components/evalist.vue';
import Alarmlist from './components/alarmlist.vue';
export default {
   components:{evaList,Alarmlist},
  data() {
    return {
      addForm: {},
      dialogTitle: '新增',
      showDialogVisible: false,
      showDialogVisible1:false,
      rules: {
        postName: [
          {
            required: true,
            message: '请输入职位名',
            trigger: 'blur'
          }
        ],
        postSort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      isEva:false,
      isAlarm:false,
      customerId:''
    }
  },
  methods: {
    deleteItem(id) {
      this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await post('/rbac/admin/post/delete', { id: id })
          if (res.code == 200) {
            this.getTableData()
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    async send() {
      let url
      if (this.dialogTitle === '新增') {
        url = '/rbac/admin/post/save'
      } else {
        url = '/rbac/admin/post/update'
      }
      const res = await post(url, this.addForm)
      this.getTableData()
      this.dialogClose()
    },
    dialogClose() {
      this.showDialogVisible = false
      this.showDialogVisible1=false
      this.isEva=false
      this.isAlarm=false
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    //获取列表数据
    async getTableData() {
       this.searchlist.isEquCustomer=1
      const { content } = await post('/ypt/admin/all/customer/info/findList', {
        ...this.searchlist,
        ...this.pageConfig
      })
      this.tableData = content.list || []
      this.pageConfig.total = content.count
    },
    async showDialog(type, row) {
      this.customerId=row.id
      if(type=='健康报告'){
        this.showDialogVisible=true
        this.isEva=true
      }else{
        this.isAlarm=true
        this.showDialogVisible1=true
      }
      this.dialogTitle = type
    }
  },
  created() {
    if(this.$route.params.customerName){
       this.searchlist.customerName=this.$route.params.customerName
    }
    this.getTableData()
  }
}
</script>
<style scoped>
.tabBtn {
  font-size: 13px;
  margin: 0 3px;
}
</style>
